import {useTranslation} from "react-i18next";
import {useDispatch, useSelector} from "react-redux";
import {useEffect, useState} from "react";
import {EmailSettings} from "../../../../models/EmailSettings";
import {GetEmailSetting, UpdateEmailSetting} from "../../../../reduxToolkit/EmployeePayRoll/EmployeePayRollApi";
import {isEmailFormat} from "../../../../Apis/functions";
import { toast } from 'react-toastify';
/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */

const EmailSettingApp = () => {
    // Translation hook for localization
    const { t } = useTranslation();
    const dispatch = useDispatch('');
    const DEV = useSelector((state) => state?.CommonsSlice?.development);
    //use Selector hook to get state for redux store
    const { getEmailSetting } = useSelector((state) => state.employeePayrollSlice);
    const { permission } = useSelector((state) => state.authenticatioauthennSlice);

    //use State hook for local state management
    const [isValidEmail, setIsValidEmail] = useState(true);
    const [emptyFields, setEmptyFields] = useState(false);
    const [settings, setSettings] = useState(EmailSettings);

    const handleEmailChange = (e) => {
        validateEmail(e); // Run the function validateEmail
    };

    const validateEmail = (e) => {
        const { value } = e?.target;
        if (value === null || value === undefined) {
            setIsValidEmail(isEmailFormat(settings.email));
        } else {
            setIsValidEmail(isEmailFormat(value));
        }
    };
    const clearAllState = () => {
        setSettings((prev) => ({
            ...prev,
            email: '',
            password: '',
            imapHost: '',
            port: '',
        }));
    };
    // A funtion to manage payload and dispatch update email setting
    const handelEmailSettingUpdate = () => {
        if (settings.email === '' || settings.password === '' || settings.imapHost === '' || settings.port === '') {
            setEmptyFields(true);
        } else {
            dispatch(UpdateEmailSetting(settings.toUpdateEmailSettings())).then(
                ({
                     payload: {
                         data: { success },
                     },
                 }) => {
                    if (success === true) {
                        dispatch(GetEmailSetting());
                        setEmptyFields(false);
                        toast.success(t('has_been_updated_successfully'));
                    }
                },
            );
        }
    };

    // The view can be opened directly, so it loads its own data instead of relying on the store
    useEffect(() => {
        dispatch(GetEmailSetting());
    }, [dispatch]);

    useEffect(() => {
        setSettings((prevData) => ({
            ...prevData,
            ...getEmailSetting,
            password: '',
        }));
    }, [getEmailSetting]);

    return {
        t,
        DEV,
        permission,
        emptyFields,
        settings,
        setSettings,
        isValidEmail,
        handleEmailChange,
        handelEmailSettingUpdate,
        clearAllState,
    };
};

export default EmailSettingApp;
